import { combineReducers } from "redux";
import activeTab from "./ActiveTab";
import dashboardPreference from "./Preference";

export default combineReducers({
  activeTab,
  preferences: dashboardPreference,
});
